export default __webpack_public_path__ + "static/media/noMessage.0a9a31fb.svg";